import { SearchDropdownState, SearchState } from '@/state';
import { ActionType, RootAction } from '@/actions/actiontypes';
import { StedsnavnResponse } from '@/server/responses';

const initialState = new SearchState();

export const searchReducer = (
    searchState: SearchState = initialState,
    action: RootAction
) => {
    switch (action.type) {
        // Start-up & hash
        case ActionType.BOOTSTRAP:
            return action.bootstrappedState.searchState;
        case ActionType.HASH_CHANGED:
            return action.state.searchState;
        // Search
        case ActionType.ADD_SEARCH_QUERY:
            return searchState.withRecentSearchQueries(action.searchQuery);
        case ActionType.SEARCH_DROPDOWN_SET:
            if (action.searchDropdownState.searchText.length === 0) {
                return searchState
                    .withPlaceNames(new StedsnavnResponse(0, []))
                    .withDropdownState(action.searchDropdownState);
            }
            return searchState.withDropdownState(action.searchDropdownState);
        case ActionType.SEARCH_TIMESTAMP_SET:
            return searchState.withDropdownState(
                searchState.searchDropdownState?.withTimestamp(action.date) ??
                    new SearchDropdownState()
            );
        case ActionType.SEARCH_STEDSNAVN_RECEIVED:
            if (action.append && searchState.placeNames) {
                // Append new place names to existing ones
                const combinedPlaceNames = [
                    ...searchState.placeNames.placeNames,
                    ...action.stedsnavn.placeNames,
                ];
                return searchState.withPlaceNames(
                    new StedsnavnResponse(action.stedsnavn.hits, combinedPlaceNames)
                );
            }
            return searchState.withPlaceNames(action.stedsnavn);
        case ActionType.SEARCH_STEDSNAVN_CLEARED:
            return searchState.withPlaceNames({ placeNames: [], hits: 0 });

        // Mobile
        case ActionType.MOBILE_FILTER_OPEN_SET:
            return searchState.withFilterPanelOpen(action.filterPanelOpen);
        case ActionType.MOBILE_SEARCH_OPEN_SET:
            return searchState.withSearchPanelOpen(action.searchPanelOpen);
        default:
            return searchState;
    }
};
